module.exports = __webpack_public_path__ + "static/media/p054_poker.eef3c901.txt";